// extracted by mini-css-extract-plugin
export default {"metaList":"MetaList-module__metaList--RyDQT"};